(function () {
  angular
   .module('kareo.ui.shared.directives.user.k-password-requirements', [
     'kareo.ui.shared.modules.api.user.k-user-service'
   ])
   .directive('kPasswordRequirements', kPasswordRequirements);

  function kPasswordRequirements() {
    return {
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {},
      template: require('./k-password-requirements.pug')()
    };
  }

  controller.$inject = ['kUserService'];

  function controller(kUserService) {
    const vm = this;

    vm.passwordValidationRequirements = [];

    init();

    function init() {
      kUserService.getPasswordRequirementsForCustomer()
        .then((response) => {
          vm.passwordValidationRequirements = response;
        });
    }
  }
})();
